import React, { memo, SVGProps } from 'react'

export const MinusInCircle = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}>
    <path
      d="M11.9995 21.1966C16.7793 21.1966 20.6692 17.2952 20.6692 12.5C20.6692 7.70478 16.7793 3.80334 11.9995 3.80334C7.21965 3.80334 3.33069 7.70382 3.33069 12.5C3.33069 17.2961 7.21965 21.1966 11.9995 21.1966ZM11.9995 5.24334C15.9854 5.24334 19.2292 8.4987 19.2292 12.5C19.2292 16.5013 15.9864 19.7566 11.9995 19.7566C8.01261 19.7566 4.77069 16.5013 4.77069 12.5C4.77069 8.4987 8.01357 5.24334 11.9995 5.24334Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33067 12.5534C7.33067 12.1391 7.66645 11.8034 8.08067 11.8034H15.5807C15.9949 11.8034 16.3307 12.1391 16.3307 12.5534C16.3307 12.9676 15.9949 13.3034 15.5807 13.3034H8.08067C7.66645 13.3034 7.33067 12.9676 7.33067 12.5534Z"
      fill="currentColor"
    />
  </svg>
))
